import _toConsumableArray from '@babel/runtime/helpers/esm/toConsumableArray';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React from 'react';
import { v4 } from 'uuid';
import { get, isFunction, curry, cloneDeep, set } from '@elliemae/ds-utilities/utils';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var appendHeaderFormatter = curry(function (formatter, column) {
  return _objectSpread(_objectSpread({}, column), {}, {
    header: _objectSpread(_objectSpread({}, column.header), {}, {
      formatters: [].concat(_toConsumableArray(get(column, 'header.formatters', [])), [formatter])
    })
  });
});
var appendCellFormatter = curry(function (formatter, column) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'formatters';
  var nextColumn = cloneDeep(column);
  var formatters = get(nextColumn, ['cell', path], []);
  var scrollingFormatters = get(nextColumn, 'cell.scrollingFormatters', []);

  if (Array.isArray(formatter)) {
    if (formatter[1]) scrollingFormatters.push(formatter[1]);
    formatters.push(formatter[0]);
  } else {
    formatters.push(formatter);
    scrollingFormatters.push(formatter);
  }

  set(nextColumn, ['cell', path], formatters);
  set(nextColumn, 'cell.scrollingFormatters', scrollingFormatters);
  return nextColumn;
});
var defaultColumnDefinitionOptions = {
  normalize: false,
  useTextTruncation: true,
  isUserColumn: true,
  visible: true
};
var mergeClassNameToColumnHeader = curry(function (className, column) {
  var headerProps = get(column, ['header', 'props'], {});
  var headerClassName = headerProps.className || '';
  return _objectSpread(_objectSpread({}, column), {}, {
    header: _objectSpread(_objectSpread({}, column.header), {}, {
      props: _objectSpread(_objectSpread({}, headerProps), {}, {
        className: "".concat(headerClassName, " ").concat(className)
      })
    })
  });
});
function initColumnDefinition() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  // eslint-disable-next-line complexity
  return function (column) {
    // todo: clean this
    if (column.type === 'number') {
      // eslint-disable-next-line no-param-reassign
      column.cellStyle = {
        textAlign: 'right'
      };
    }

    var _defaultColumnDefinit = _objectSpread(_objectSpread({}, defaultColumnDefinitionOptions), options),
        _defaultColumnDefinit2 = _defaultColumnDefinit.useTextTruncation,
        useTextTruncation = _defaultColumnDefinit2 === void 0 ? true : _defaultColumnDefinit2,
        isUserColumn = _defaultColumnDefinit.isUserColumn,
        visible = _defaultColumnDefinit.visible,
        normalize = _defaultColumnDefinit.normalize;

    if (normalize) {
      // eslint-disable-next-line no-param-reassign
      column.originalProperty = column.property; // eslint-disable-next-line no-param-reassign

      column.property = column.property.replace(/\s+/g, '');
    } // eslint-disable-next-line no-param-reassign


    column.props = _objectSpread(_objectSpread({}, column.props), {}, {
      style: {}
    }); // eslint-disable-next-line no-param-reassign

    column.header = _objectSpread(_objectSpread({}, column.header), {}, {
      label: column.label,
      formatters: _toConsumableArray(get(column, ['header', 'formatters'], [])),
      props: {
        style: column.headerStyle || {}
      }
    });

    if (useTextTruncation && !(isFunction(column.customHeaderRenderer) || column.header.formatters.length)) {
      column.header.formatters.push(function (value) {
        return /*#__PURE__*/React.createElement("span", {
          className: "cell-value"
        }, value);
      });
    } // eslint-disable-next-line no-param-reassign


    column.cell = _objectSpread(_objectSpread({}, column.cell), {}, {
      transforms: [],
      formatters: _toConsumableArray(get(column, ['cell', 'formatters'], [])),
      scrollingFormatters: _toConsumableArray(get(column, ['cell', 'formatters'], [])),
      props: {
        style: column.cellStyle || {}
      }
    });

    if (useTextTruncation && !(isFunction(column.customRenderer) || column.cell.formatters.length)) {
      column.cell.formatters.push(function (value) {
        return /*#__PURE__*/React.createElement("span", {
          className: "cell-value",
          style: {
            justifyContent: column.type === 'number' ? 'flex-end' : 'flex-start'
          }
        }, value);
      });
    } // eslint-disable-next-line no-param-reassign


    column.uuid = column.uuid || v4(); // eslint-disable-next-line no-param-reassign

    column.visible = column.visible === undefined ? visible : column.visible; // eslint-disable-next-line no-param-reassign, max-lines

    column.isUserColumn = column.isUserColumn || isUserColumn; // eslint-disable-next-line no-param-reassign

    column.headerHookEffects = [];
    return column;
  };
}

export default initColumnDefinition;
export { appendCellFormatter, appendHeaderFormatter, mergeClassNameToColumnHeader };
//# sourceMappingURL=initColumnDefinition.js.map
